import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";
import { getSessionToken } from "@/lib/authToken";

// Cross-domain auth fallback: always attach the persisted session_token as a
// Bearer header so the backend can authenticate requests when SameSite=None
// cookies get blocked by 3rd-party cookie rules.
//
// Also: force withCredentials=false on every request. Production deployment
// has frontend and backend on different top-level domains; sending
// credentials triggers the CORS wildcard-origin rejection when the edge
// proxy overrides Access-Control-Allow-Origin to '*'. Bearer auth works
// without credentials, so we disable them globally.
axios.defaults.withCredentials = false;
axios.interceptors.request.use((config) => {
  // Force credentials off regardless of per-call overrides
  config.withCredentials = false;
  const token = getSessionToken();
  if (token) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
